import { render } from "./DayIntake.vue?vue&type=template&id=d648f3a2"
import script from "./DayIntake.vue?vue&type=script&lang=ts"
export * from "./DayIntake.vue?vue&type=script&lang=ts"
script.render = render

export default script